import { Link } from 'react-router-dom';
import { formatCompactDate, formatSetlistContext, pluralizeSongs } from '../lib/format';
import type { SetlistOverview } from '../types/database';

export function SetlistCard({ item, compact = false }: { item: SetlistOverview; compact?: boolean }) {
  return (
    <Link to={`/setlist/${item.id}`} className={`setlist-card ${compact ? 'card-compact' : ''} ${item.poster_url ? 'has-poster' : ''}`}>
      <div className="card-date" aria-label={`공연 날짜 ${item.performance_date}`}>
        <span>{formatCompactDate(item.performance_date).slice(5)}</span>
        <small>{item.performance_date.slice(0, 4)}</small>
      </div>
      <div className="card-body">
        <div className="eyebrow-row">
          <span className="pill">{item.festival_name ? '페스티벌' : '공연'}</span>
          <span>{pluralizeSongs(item.song_count)}</span>
        </div>
        <h3>{item.artist_name}</h3>
        <p>{formatSetlistContext(item.artist_name, item.concert_title, item.tour_name)}</p>
        <div className="card-location">
          <span>{item.venue_name || '공연장 미정'}</span>
          <small>{item.region || '지역 미정'}</small>
        </div>
      </div>
      {item.poster_url && <img className="card-poster" src={item.poster_url} alt={`${item.artist_name} 공연 포스터`} loading="lazy" />}
      <span className="card-arrow" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="m7 17 10-10M7 7h10v10" /></svg></span>
    </Link>
  );
}
